/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Invite_X15_Signin_BodyInputs */

const en_invite_x15_signin_body = /** @type {(inputs: Invite_X15_Signin_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sign in to accept. Use Google, or we email a sign-in link to ${i?.email}. You can set a password after you join.`)
};

/**
* | output |
* | --- |
* | "Sign in to accept. Use Google, or we email a sign-in link to {email}. You can set a password after you join." |
*
* @param {Invite_X15_Signin_BodyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const invite_x15_signin_body = /** @type {((inputs: Invite_X15_Signin_BodyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_X15_Signin_BodyInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_invite_x15_signin_body(inputs)
});